import { Expand } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ExpandIcon = DeckardIconWrapper({ Icon: Expand });
